import { type Hit } from 'algoliasearch'

import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_DYNAMIC_RANKING } from '../model/EXPERIMENT_NAME'

export const ALGOLIA_DYNAMIC_RANKING_STATUS_KEY =
  'algolia-dynamic-re-ranking-status'

export const useCheckAndStoreAlgoliaDynamicRankingStatus = (
  hits: Hit[],
): void => {
  const dynamicRankingExperiment = useGetExperiment(
    EXPERIMENT_NAME_DYNAMIC_RANKING,
  )
  const isDynamicRankingEnabled = dynamicRankingExperiment.isEnabled
  if (isDynamicRankingEnabled) {
    const isDynamicRankingActive = hits.some(
      // eslint-disable-next-line no-underscore-dangle -- algolia code
      (hit) => hit._rankingInfo?.promotedByReRanking === true,
    )
    if (isDynamicRankingActive) {
      sessionStorage.setItem(ALGOLIA_DYNAMIC_RANKING_STATUS_KEY, 'true')
    } else {
      sessionStorage.removeItem(ALGOLIA_DYNAMIC_RANKING_STATUS_KEY)
    }
  }
}
